import { API_BASE_URL } from "./config";
import { buildHeaders, refreshToken } from "./httpClient";

// Headers par défaut : JSON + X-React-Admin + Authorization (Bearer) quand un
// token admin est en session. buildHeaders est partagé avec httpClient pour
// que tous les appels du BO soient authentifiés de la même façon.
const defaultHeaders = () =>
  buildHeaders({ "Content-Type": "application/json" });

export async function apiGet(path, params = {}) {
  await refreshToken();
  const url = new URL(`${API_BASE_URL}${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") url.searchParams.set(k, v);
  });
  const res = await fetch(url.toString(), {
    method: "GET",
    headers: defaultHeaders(),
  });
  if (!res.ok) {
    const err = new Error(res.statusText || "API Error");
    err.status = res.status;
    err.body = await res.text();
    try {
      err.json = JSON.parse(err.body);
    } catch (_) {}
    throw err;
  }
  return res.json();
}

export async function apiPost(path, body = {}) {
  await refreshToken();
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: defaultHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(res.statusText || "API Error");
    err.status = res.status;
    err.body = await res.text();
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}

export async function apiPut(path, body = {}) {
  await refreshToken();
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "PUT",
    headers: defaultHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(res.statusText || "API Error");
    err.status = res.status;
    err.body = await res.text();
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}

export async function apiDelete(path) {
  await refreshToken();
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "DELETE",
    headers: defaultHeaders(),
  });
  if (!res.ok) {
    const err = new Error(res.statusText || "API Error");
    err.status = res.status;
    err.body = await res.text();
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}
